import * as type from "../types/clients";

const initialState = {
  companyClients: [],
  personClients: [],
  deletionArray: [],
  activeClient: null,
  fetchCompanyClients: {
    error: null,
    loading: true,
  },
  fetchPersonClients: {
    error: null,
    loading: true,
  },
  deleteClient: {
    status: null,
    loading: false,
    error: null,
  },
  updateClient: {
    status: null,
    loading: false,
    error: null,
  },
  addClient: {
    status: null,
    loading: false,
    error: null,
  },
  searchClient: {
    status: null,
    loading: false,
    error: null,
  },
  activeDeletion: {
    id: null,
    type: null,
  },
  deleteArray: {
    status: null,
    loading: false,
    error: null,
  },
  showModals: {
    addModal: false,
    editModal: false,
    deleteModal: false,
  },
};

export const clients = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_COMPANY_CLIENTS_CONTENT:
      return {
        ...state,
        fetchCompanyClients: {
          ...state.fetchCompanyClients,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_COMPANY_CLIENTS_CONTENT:
      return {
        ...state,
        companyClients: [],
        fetchCompanyClients: {
          ...state.fetchCompanyClients,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_COMPANY_CLIENTS_CONTENT:
      return {
        ...state,
        companyClients: payload.content,
        fetchCompanyClients: {
          ...state.fetchCompanyClients,
          error: null,
          loading: false,
        },
      };
    case type.RESET_COMPANY_CLIENTS_CONTENT:
      return {
        ...state,
        companyClients: [],
        fetchCompanyClients: {
          ...state.fetchCompanyClients,
          error: null,
          loading: false,
        },
      };
    case type.REQUEST_PERSON_CLIENTS_CONTENT:
      return {
        ...state,
        fetchPersonClients: {
          ...state.fetchPersonClients,
          error: null,
          loading: true,
        },
      };
    case type.REVOKE_PERSON_CLIENTS_CONTENT:
      return {
        ...state,
        personClients: [],
        fetchPersonClients: {
          ...state.fetchPersonClients,
          error: payload.message,
          loading: false,
        },
      };
    case type.SET_PERSON_CLIENTS_CONTENT:
      return {
        ...state,
        personClients: payload.content,
        fetchPersonClients: {
          ...state.fetchPersonClients,
          error: null,
          loading: false,
        },
      };
    case type.RESET_PERSON_CLIENTS_CONTENT:
      return {
        ...state,
        personClients: [],
        fetchPersonClients: {
          ...state.fetchPersonClients,
          error: null,
          loading: false,
        },
      };
    case type.CHANGE_CLIENTS_MODALS:
      if (payload.modal.addModal === true || payload.modal.addModal === false) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            addModal: payload.modal.addModal,
          },
        };
      } else if (
        payload.modal.editModal === true ||
        payload.modal.editModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editModal: payload.modal.editModal,
          },
        };
      } else if (
        payload.modal.deleteModal === true ||
        payload.modal.deleteModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            deleteModal: payload.modal.deleteModal,
          },
        };
      } else {
        return state;
      }
    case type.SET_ACTIVE_CLIENT_DELETION:
      return {
        ...state,
        activeDeletion: {
          ...state.activeDeletion,
          type: payload.data.type,
          id: payload.data.id,
        },
      };
    case type.RESET_ACTIVE_CLIENT_DELETION:
      return {
        ...state,
        activeDeletion: {
          type: null,
          id: null,
        },
      };
    case type.SET_ACTIVE_CLIENT_DISPLAY:
      return {
        ...state,
        activeClient: payload.client,
      };
    case type.RESET_ACTIVE_CLIENT_DISPLAY:
      return {
        ...state,
        activeClient: null,
      };
    case type.REQUEST_UPDATE_SINGLE_CLIENT:
      return {
        ...state,
        updateClient: {
          ...state.updateClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_CLIENT:
      return {
        ...state,
        updateClient: {
          ...state.updateClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_SINGLE_CLIENT:
      return {
        ...state,
        updateClient: {
          ...state.updateClient,
          status: payload.update,
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_SINGLE_CLIENT:
      return {
        ...state,
        updateClient: {
          ...state.updateClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_DELETE_SINGLE_CLIENT:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_SINGLE_CLIENT:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_SINGLE_CLIENT:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: payload.update,
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_SINGLE_CLIENT:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_SEARCH_SINGLE_CLIENT:
      return {
        ...state,
        searchClient: {
          ...state.searchClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SEARCH_SINGLE_CLIENT:
      return {
        ...state,
        searchClient: {
          ...state.searchClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_SEARCH_SINGLE_CLIENT:
      return {
        ...state,
        searchClient: {
          ...state.searchClient,
          status: payload.response,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SEARCH_SINGLE_CLIENT:
      return {
        ...state,
        searchClient: {
          ...state.searchClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_SINGLE_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.GRANT_ADD_SINGLE_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: payload.update,
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_ADD_SINGLE_CLIENT:
      return {
        ...state,
        addClient: {
          ...state.addClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.APPEND_CLIENTS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: [...state.deletionArray, payload.id],
      };
    case type.SUBTRACT_CLIENTS_DELETION_ARRAY:
      return {
        ...state,
        deletionArray: state.deletionArray.filter(
          (existing) => existing !== payload.id
        ),
      };
    case type.REQUEST_DELETE_CLIENT_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_DELETE_CLIENT_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_DELETE_CLIENT_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_DELETE_CLIENT_ARRAY:
      return {
        ...state,
        deleteArray: {
          ...state.deleteArray,
          status: null,
          loading: false,
          error: null,
        },
      };
    default:
      return state;
  }
};
